module.exports = __webpack_public_path__ + "BebasNeue-webfont.069d21431b01588b7f1a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/assets/fonts/BebasNeue-webfont.eot
// module id = ../../../../../src/assets/fonts/BebasNeue-webfont.eot
// module chunks = styles